<template>
  <div class="home h-view overflow-auto">
    <!-- Desktop version -->
    <div class="h-view bg-ul-orange-300 text-ul-orange-100 font-display relative hidden font-medium lg:block">
      <div class="flex h-5/6 flex-row">
        <div class="relative w-1/2 text-white">
          <!-- <img
          :srcSet="pinsImageSourceSet"
          :sizes="pinsSizes"
          :src="pinsImage2k"
          role="presentation"
          class="w-full h-full object-cover"
          /> -->
          <img :src="ul24Image" role="presentation" class="h-full w-full object-cover" />
          <div class="absolute inset-x-0 bottom-1/12 flex flex-col items-center justify-center gap-2">
            <h1 class="text-10xl xl:text-11xl xxl:text-12xl xxxl:text-14xl text-center leading-none">UL26</h1>
            <h2 class="xxl:text-6xl xxxl:text-7xl text-center text-4xl leading-none xl:text-5xl">
              21-25. juli i Lyngdal!
            </h2>
          </div>
          <!-- <h2 class="absolute inset-x-0 bottom-1/4 text-center text-4xl xl:text-5xl xxl:text-6xl xxxl:text-7xl">
            Tema: Sted
          </h2> -->
        </div>
        <div class="flex w-1/2 flex-col">
          <VideoPlayer
            url="https://firebasestorage.googleapis.com/v0/b/ulno-1557913587891.appspot.com/o/video%2FUL_8.mp4?alt=media"
            :poster="ulVideoPoster"
            class="shrink-0"
          />
          <!-- <div v-if="isStreamActive" class="h-3/5 bg-black">
            <iframe
              id="ytplayer"
              type="text/html"
              width="100%"
              height="100%"
              :src="streamEmbedUrl"
              frameborder="0"
              allow="fullscreen;"
            />
          </div> -->
          <!-- <div class="flex flex-row h-3/5">
            <div class="flex flex-col w-3/5">
              <div class="flex flex-row h-full">
                <div class="flex flex-col w-1/3">
                  <img :src="lotteryImage" role="presentation" class="w-full h-1/2 object-cover" />
                  <img :src="praise2Image" role="presentation" class="w-full h-1/2 object-cover" />
                </div>
                <div class="flex flex-col w-2/3">
                  <img :src="bikeImage" role="presentation" class="w-full h-full object-cover" />
                </div>
              </div>
              <!- <a
                class="h-1/3 flex flex-row justify-center items-center text-center text-3xl xl:text-4xl xxl:text-6xl xxxl:text-7xl bg-ul-orange-400 underline underline-offset-8"
                href="https://www.youtube.com/@ul-festivalsomforandrer3406"
              >
                Se UL26 i reprise!
              </a> ->
            </div>
            <div class="flex flex-col w-2/5">
              <img :src="wetsuitImage" role="presentation" class="w-full h-3/8 object-cover" />
              <div
                class="flex justify-center items-center h-1/4 text-center text-4xl xl:text-5xl xxl:text-6xl xxxl:text-8xl"
              >
                21-25. juli
              </div>
              <img :src="cheerImage" role="presentation" class="w-full h-3/8 object-cover" />
            </div>
          </div> -->
          <div class="min-h-1/5 grow">
            <img :src="praiseImage" role="presentation" class="h-full w-full object-cover" />
          </div>
        </div>
      </div>
      <div class="flex h-1/6 w-full flex-row">
        <div class="flex h-full w-1/2 flex-row">
          <img :src="discGolfImage" role="presentation" class="h-full w-1/4 object-cover" />
          <!-- <div
            v-if="isStreamActive"
            class="flex justify-center items-center h-full grow text-center text-4xl xl:text-5xl xxl:text-6xl xxxl:text-8xl"
          >
            21-25. juli
          </div>
          <GridImageButton v-else :image="screamImage" text="Kjøp billett!" link="/billetter" class="w-3/8 text-5xl" /> -->
          <img :src="screamImage" role="presentation" class="h-full w-3/8 object-cover" />
          <img :src="surfImage" role="presentation" class="h-full w-1/4 object-cover" />
          <img :src="confettiImage" role="presentation" class="h-full w-1/8 object-cover" />
        </div>
        <div class="flex h-full w-1/2 flex-row">
          <img :src="smileImage" role="presentation" class="h-full w-1/4 object-cover" />
          <div
            class="xxl:text-5xl xxxl:text-6xl xxxxl:text-7xl flex h-full w-3/8 items-center justify-center text-center text-3xl xl:text-4xl"
          >
            Festival som forandrer
          </div>
          <img :src="shadesImage" role="presentation" class="h-full w-3/8 object-cover" />
        </div>
      </div>
    </div>

    <!-- Mobile version -->
    <div class="h-view bg-ul-orange-300 text-ul-orange-100 font-display relative font-medium lg:hidden">
      <div class="flex h-full flex-col">
        <VideoPlayer
          url="https://firebasestorage.googleapis.com/v0/b/ulno-1557913587891.appspot.com/o/video%2FUL_8.mp4?alt=media"
          :poster="ulVideoPoster"
          class="shrink-0"
        />

        <!-- <div class="relative w-full h-1/3 text-white">
          <!- <img
            :srcSet="pinsImageSourceSet"
            :sizes="pinsSizes"
            :src="pinsImage2k"
            role="presentation"
            class="w-full h-full object-cover"
          /> ->
          <img :src="ul24Image" role="presentation" class="w-full h-full object-cover" />
          <div class="absolute inset-x-0 bottom-8 flex flex-col items-center justify-center gap-2">
            <h1 class="text-center leading-none text-6xl xs:text-7xl sm:text-8xl md:text-9xl">UL26</h1>
            <h2 class="text-center leading-none text-2xl xs:text-3xl sm:text-4xl md:text-5xl">
              21-25. juli i Lyngdal!
            </h2>
          </div>
        </div> -->

        <div class="flex h-1/8 flex-row">
          <img :src="wetsuitImage" role="presentation" class="h-full w-2/5 object-cover" />
          <div class="xs:text-5xl flex w-3/5 items-center justify-center text-center text-4xl sm:text-6xl md:text-7xl">
            {{ EVENT_DATE }}
          </div>
        </div>

        <!-- <a
          :href="streamLinkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="h-1/6 flex justify-center items-center text-center text-4xl xs:text-5xl sm:text-6xl md:text-8xl underline underline-offset-8 bg-ul-orange-400"
        >
          Se UL direkte nå!
        </a> -->
        <!-- <a
          href="https://www.youtube.com/@ul-festivalsomforandrer3406"
          target="_blank"
          rel="noopener noreferrer"
          class="h-1/6 flex justify-center items-center text-center text-3xl xs:text-4xl sm:text-5xl md:text-7xl underline underline-offset-8 bg-ul-orange-400"
        >
          Se UL26 i reprise!
        </a> -->
        <!-- <img :src="praiseImage" role="presentation" class="w-full h-1/6 object-cover" /> -->

        <div class="xs:text-4xl flex h-1/8 items-center justify-center text-center text-3xl sm:text-5xl md:text-6xl">
          Lyngdal
        </div>

        <div class="flex h-1/8 grow flex-row">
          <img :src="smileImage" role="presentation" class="h-full w-1/3 object-cover" />
          <img :src="shadesImage" role="presentation" class="h-full w-1/2 object-cover" />
          <img :src="discGolfImage" role="presentation" class="h-full w-1/6 object-cover" />
        </div>

        <div class="flex h-1/8 flex-row">
          <div class="xs:text-3xl flex w-2/5 items-center justify-center text-center text-2xl sm:text-4xl md:text-5xl">
            Festival som forandrer
          </div>
          <img :src="screamImage" role="presentation" class="h-full w-3/5 object-cover" />
        </div>
      </div>
    </div>

    <div class="bg-ul-orange-400 flex flex-col">
      <AboutArticle v-for="(article, idx) in homeAboutArticles" :key="article.id" :article="article" :index="idx" />
    </div>

    <div class="bg-ul-orange-200 flex items-center justify-center">
      <div class="flex max-w-(--breakpoint-xl) flex-col items-center justify-center gap-12 p-12 lg:flex-row-reverse">
        <VideoPlayer
          url="https://firebasestorage.googleapis.com/v0/b/ulno-1557913587891.appspot.com/o/video%2FUL%2B.mp4?alt=media"
          class="border-12 border-white object-cover lg:w-1/2"
        />
        <div class="flex flex-col gap-8">
          <p class="text-center text-lg lg:text-right">
            Velkommen på UL+! Festival i festivalen UL, for deg som er 21 år eller eldre. Vi har vår egen lounge, eget
            program- og alt er skreddersydd for oss!
          </p>
          <router-link
            to="ul-pluss"
            class="text-ul-orange-400 font-display border-ul-orange-400 hover:bg-ul-orange-150 border-2 px-4 py-2 text-center text-2xl font-bold"
          >
            Les mer
          </router-link>
        </div>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import confettiImage from '../assets/images/confetti.jpg'
import discGolfImage from '../assets/images/discgolf.png'
import praiseImage from '../assets/images/praise.jpg'
import screamImage from '../assets/images/scream.png'
import shadesImage from '../assets/images/shades.jpg'
import smileImage from '../assets/images/smile.jpg'
import surfImage from '../assets/images/surf.jpg'
import ul24Image from '../assets/images/ul24.jpg'
import ulVideoPoster from '../assets/images/ul-video-poster.png'
import wetsuitImage from '../assets/images/wetsuit.jpg'
import AboutArticle from '../components/AboutArticle.vue'
import PageFooter from '../components/PageFooter.vue'
import { useAboutStore } from '../stores/about'
import { useStreamStore } from '../stores/stream'
import { useTicketStore } from '../stores/ticket'
import VideoPlayer from '../components/VideoPlayer.vue'
import { EVENT_DATE } from '../lib/constants'

const homeAboutArticles = useAboutStore()
  .articles.toSorted((a, b) => b.priority - a.priority)
  .filter((article) => article.frontpage)

const ticketStore = useTicketStore()
const tickets = computed(() => ticketStore.tickets)

const streamStore = useStreamStore()
const streamId = computed(() => streamStore.streamId)
const isStreamActive = computed(() => (streamId.value?.length ?? '') > 0)
const streamEmbedUrl = computed(() => `https://www.youtube.com/embed/${streamId.value}?origin=https://ul.no`)
const streamLinkUrl = computed(() => `https://www.youtube.com/watch?v=${streamId.value}`)
const nextStreamDate = computed(() => streamStore.nextStreamDate)
const formattedNextStreamDate = computed(() => {
  if (!nextStreamDate.value) return ''
  const date = new Date(nextStreamDate.value)
  return date.toLocaleDateString('nb-NO', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
})
</script>

<style scoped>
.home div {
  @apply overflow-hidden;
}
</style>
